import { LogOut, ShieldCheck } from 'lucide-react';
import QRCode from 'qrcode';
import { FormEvent, useEffect, useState } from 'react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';

export function MfaSetupPage() {
  const { admin, logout, refreshAdmin } = useAuth();
  const [qrDataUrl, setQrDataUrl] = useState('');
  const [secret, setSecret] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    api<{ secret: string; otpauthUrl: string }>('/auth/mfa/setup', { method: 'POST' })
      .then(async (result) => {
        setSecret(result.secret);
        setQrDataUrl(await QRCode.toDataURL(result.otpauthUrl));
      })
      .catch(() => setError('Não foi possível preparar a configuração. Tenta novamente.'));
  }, []);

  async function confirmEnable(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError('');
    try {
      await api('/auth/mfa/enable', {
        method: 'POST',
        body: JSON.stringify({ secret, code }),
      });
      await refreshAdmin();
    } catch {
      setError('Código inválido. Confirma a hora do telemóvel e tenta novamente.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="app-loading">
      <div className="modal mfa-required-card">
        <div className="modal__heading">
          <div>
            <span className="eyebrow">Segurança obrigatória</span>
            <h2>Configura a autenticação de dois fatores</h2>
          </div>
          <ShieldCheck size={24} />
        </div>
        <p>
          Olá, {admin?.fullName}. Por política de segurança, todas as contas do backoffice
          precisam de MFA ativo. Configura a tua aplicação de autenticação para continuar.
        </p>
        {qrDataUrl ? (
          <form className="mfa-setup" onSubmit={confirmEnable}>
            <p>1. Digitaliza este código com a tua aplicação de autenticação (Google Authenticator, 1Password, Authy, etc.):</p>
            <img className="mfa-qr" src={qrDataUrl} alt="Código QR de configuração MFA" />
            <p>Ou insere manualmente: <code>{secret}</code></p>
            <label>
              2. Código de 6 dígitos
              <input
                value={code}
                onChange={(event) => setCode(event.target.value)}
                required
                minLength={6}
                maxLength={8}
                inputMode="numeric"
                autoFocus
              />
            </label>
            {error && <div className="form-error">{error}</div>}
            <div className="modal__actions">
              <button type="button" className="button button--secondary" onClick={() => void logout()}>
                <LogOut size={16} /> Terminar sessão
              </button>
              <button className="button button--primary" disabled={busy}>
                {busy ? 'A confirmar…' : 'Confirmar e ativar'}
              </button>
            </div>
          </form>
        ) : (
          error && <div className="form-error">{error}</div>
        )}
      </div>
    </div>
  );
}
